var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "content-subject" },
    [
      _vm.container
        ? [
            _c(
              "div",
              {
                class: {
                  fluid: _vm.isFluid,
                  "content-wrapper-subject": !_vm.classic,
                  "content-wrapper-simple": _vm.classic
                }
              },
              [_vm._t("default")],
              2
            )
          ]
        : [_vm._t("default")]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }